import { cva } from '@/styled-system/css';

export const dotRecipe = cva({
  base: {
    width: '300',
    height: '300',
    borderRadius: '150',
  },
  variants: {
    activeType: {
      forRent: {
        backgroundColor:
          'purple.400' /* oxlint-disable-line constellation/prefer-semantic-tokens -- ambiguous semantic-token suggestion, not migrating in a lint opt-in */,
      },
      offMarket: {
        backgroundColor: 'icon.action.disabled',
      },
    },
  },
});
